<template>
  <div class="exhorList">
    <ul v-if="tableData.list.length">
      <li class="exhItem" v-for="(item,i) in tableData.list" :key="i" @click="exhjump(item)">
        <div class="exhItemLeft">
          <div class="exhItemImg" >
            <img v-lazy="item.corplogo_cn" alt=""/>
          </div>
          <div class="exhDetails">
            <h2 >{{item.corpname_cn}}</h2>
            <div class="listLeft">
              <p>
                <span class="title">网址：</span>
                <span class="content">{{item.website}}</span>
              </p>
              <p>
                <span class="title">地址：</span>
                <span class="content">{{item.address_cn}}</span>
              </p>
            </div>
            <div class="listRight">
              <p>
                <span class="title">展位号：</span>
                <span class="content">{{item.booth}}</span>
              </p>
              <p>
                <span class="title">展位面积：</span>
                <span class="content">{{item.area}}m²</span>
              </p>
            </div>
          </div>
        </div>
        <div class="exhItemBtn">
          <button class="marginbottom" v-if="item.coll==1" @click.stop="collection(item)">
            <img v-lazy="hrefurl+'/public/icon/enshrine_1.png'" alt=""/>
            收&nbsp;藏
          </button>
          <div class="marginbottom" v-else @click.stop>
            <el-popconfirm title="确定要取消收藏吗？" @onConfirm='collection(item)' >
              <el-button class="btnActive" type="danger" slot="reference">
                <img v-lazy="hrefurl+'/public/icon/enshrine_1.png'" alt=""/>
                已&nbsp;收&nbsp;藏
              </el-button>
            </el-popconfirm>
          </div>
          <button @click.stop="make(item)" :class="item.corp_app==1?'':'btnActive'">
            <img v-lazy="hrefurl+'/public/icon/pack_1.png'" alt=""/>
            {{item.corp_app==1?'约见':'已约见'}}
          </button>
          
        </div>
      </li>
    </ul>
     <div class="loadingNull" v-else>
      <div class="loading" v-if="tableData.loading">
        <div>
          <img v-lazy="hrefurl+'/public/icon/loading.gif'" alt=""/>
        </div>
      </div>
      <div class="null" v-else>
        <div>
          <img v-lazy="hrefurl+'/public/icon/without.png'" alt=""/>
        </div>
        暂无数据可查看!
      </div>
    </div>
    <el-pagination
      v-if="tableData.listnum>20"
      :key="page_key"
      @current-change="handleCurrentChange"
      :current-page.sync="tableData.thispage"
      :page-size="20"
      layout="total, prev, pager, next, jumper, slot "
      :pager-count="5"
      prev-text="上一页"
      next-text="下一页"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
    <!-- 约见弹窗 start -->
    <el-dialog class="yuyue" title="在线预约" :visible.sync="dialogFormVisible" :before-close="resetForm" width="650px" top="3vh">
      <el-form ref="preAboutData" :model="preAboutData" :rules="rules" label-width="100px" size="mini">
        <el-form-item label="预约日期" prop="date">
          <el-date-picker type="date" placeholder="选择日期" v-model="preAboutData.date" :picker-options='pickerOptions' style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="留言" prop="connet">
          <el-input type="textarea" maxlength="20" show-word-limit placeholder="请输入留言" v-model="preAboutData.connet"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;margin-left:-100px">
          <el-button type="primary" @click="submitForm('preAboutData')">立即预约</el-button>
          <el-button @click="resetForm">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 约见弹窗 end -->
  </div>
</template>

<script>
import { reqCorpCollDo, reqCorpAppDo } from "../../api";
export default {
  props:["tableData","page_key"],
  data(){
    return{
      collect:false,
      meet:1,
      item:{},
      dialogFormVisible:false,//预约弹窗
      rules:{//正则校验
        // title:[{required: true, message: '请输入预约标题', trigger: 'blur'}],
        date:[{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
        // chooseTime1:[{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
        // chooseTime2:[{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
        connet:[{required: true, message: '请输入留言', trigger: 'blur'}],
      },
      preAboutData:{
        id:0,
        // title:'',
        date:"",
        // chooseTime1:"",
        // chooseTime2:"",
        connet:"",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    }
  },
  methods:{
     submitForm(formName) {//预约表单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          this.preAboutData.id=this.item.ocid
          const response = await reqCorpAppDo(this.preAboutData)
          if (response.code==0) {
            this.meet=response.is_coll
            this.success(this,'预约成功！')
            this.$emit("make",this.item.ocid,response.is_coll)
            this.$refs.preAboutData.resetFields();
            this.dialogFormVisible=false
          }else{
            this.err(this,'预约失败，请稍后重试...')
          }
        } else {//错误
          return false;
        }
      });
    },

    resetForm() {//预约表单重置
      this.$refs.preAboutData.resetFields();
      this.dialogFormVisible=false
    },

    exhjump(item){// 跳转
      if (this.jump(this)) {
        this.$router.push('/exhibitor/details/'+item.id+"/"+item.ocid)
      }
    },

    handleCurrentChange(val) {
      this.$emit("amend",val)
    },

    async collection(item){//收藏
      if (!this.jump(this)) return
      const response = await reqCorpCollDo(item.ocid)
      let collect=0
      if (response.code==0) {
        collect=response.is_coll
      }else{
        collect = item.coll
      }
      this.$emit("collect",item.ocid,collect)
    },

    async make(item){ //约见
      if (!this.jump(this)) return
      if (!(item.corp_app*1==1)) return//已预约返回
      this.item=item
      this.dialogFormVisible=true
    }
  }
};
</script>

<style scoped>
  /* 列表 21-1-28版 start*/
    .exhorList>ul{
      width: 100%;
    }
    .exhItem{
      border: 1px solid transparent;
      border-top: 1px solid #e6e6e6;
      padding: 20px 10px;
      background-color: white;
      display: flex;
      justify-content:space-between;
      cursor: pointer;
      box-sizing: border-box;
      margin-bottom: 10px;
    }
    .exhItem:hover{
      position: relative;
      box-shadow:2px 2px 5px 0 rgba(0,0,0,.1);
      border: 1px solid #e6e6e6;
      z-index: 1;
    }
    .exhItem:first-child{
      border-top: none;
    }
    .exhItemLeft{
      display: flex;
      width: calc(100% - 100px);
    }
    .exhItemImg{
      width: 120px;
      height: 120px;
      margin-right: 30px;
      border: 1px solid #aaa;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
    .exhDetails{
      line-height: 26px;
      width: calc(100% - 150px);
    }
    .exhDetails h2{
      color: #333;
      line-height: 32px;
      cursor: pointer;
      font-weight: 600;
      padding-bottom: 10px;
      width: 90%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }
    .exhDetails h2:hover{
      /* color: #f08300; */
      color: #008baf;
    }
    
    .exhDetails .listLeft{
      display: inline-block;
      width: 66%;
    }
    .listLeft .title{
      display: inline-block;
    }
    .listLeft .content{
      width: calc(100% - 92px);
      /* width: 80px; */
      height: auto;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
    .exhDetails .listRight{
      display: inline-block;
      width: 30%;
    }
    .listRight .title{
      display: inline-block;
      vertical-align: middle;
    }
    .listRight .content{
      display: inline-block;
      vertical-align: middle;
      height: auto;
      width: auto;
    }
    .exhDetails p{
      /* color: #747474; */
      color: #666666;
      font-size: 14px;
      line-height: 32px;
    }
    .exhItemBtn{
      display: flex;
      flex-direction: column;
      justify-content: left;
      padding-top: 40px;
      /* align-items: center; */
    }
    .exhItemBtn button{
      width: 100px;
      line-height: 30px;
      cursor: pointer;
      color: white;
      background-color: #008baf;
      border: 1px solid#008baf;
      border-radius: 4px;
      transition: all .5s;
      outline: none;
      /* margin-left: 20px; */
      padding: 0;
      /* box-shadow: 0 0 1px; */
    }
    .marginbottom{
      margin-bottom: 14px;
    }
    
    .exhItemBtn button:hover{
      background-color: #67c3d3;
      border-color: #67c3d3;
    }
    .exhItem .exhItemBtn .btnActive{
      background-color: #f08300;
      border-color: #f08300;
    }
    .exhItemBtn button img{
      width: 18px;
    }
  /* 列表 21-1-28版 end*/

  .exhorList>>>.el-pagination{
    padding: 30px 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .exhorList>>>.el-dialog,
  .exhorList>>>.el-pager li,
  .exhorList>>>.el-pagination,
  .exhorList>>>.el-pagination .btn-next,
  .exhorList>>>.el-pagination .btn-prev,
  .exhorList>>>.el-pagination button:disabled{
    background: none;
  }
  .exhorList>>>.el-input__icon{
    line-height: 1;
  }
  .exhorList>>>.el-table{
    color: #333;
  }
  .exhorList>>>.el-table th{
    text-align: center;
  }

  /* 加载无数据显示 */
  .loadingNull{
    width: 400px;
    text-align: center;
    margin: 140px auto;
    height: 100%;
  }
  .loading>div{
    width: 80px;
    margin: 180px auto;
  }
  .null>div{
    
    width: 200px;
    margin: 20px auto;
  }
</style>
<style scoped>
/* 预约弹窗 */
.yuyue>>> .el-dialog{
  background-color: white;
}
.yuyue >>> .el-dialog__body{
  padding: 20px 80px 20px 60px;
}
.yuyue >>>.el-form-item--mini.el-form-item,
.yuyue >>>.el-form-item--small.el-form-item{
  margin-bottom: 24px;
}
.yuyue >>>.el-form-item__label{
  line-height: 40px;
}
.yuyue >>> .el-input{
  width: 100%;
}
.yuyue >>>.el-input .el-input__inner{
  line-height: 40px;
  height: 40px;
}
.yuyue>>>.el-col-2{
  text-align: center;
  line-height: 40px;
}

.yuyue >>> .el-textarea__inner{
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
/* .yuyue >>> .el-textarea__inner:focus,
.yuyue>>>.el-input__inner:focus{
  border-color: #008baf;
} */

</style>